module.exports = require('./helpers/bundle-url').getBundleURL('l2gV3') + "logo.c51670a8.svg";